import { useState } from "react";
import LinuxImage from "../../assets/linuxIcon.png";
import { Link } from "react-router-dom";
import { GoDownload } from "react-icons/go";

const Guideline = () => {
  const devToolDownloadLink = process.env.REACT_APP_DEVTOOL_DOWNLOAD_LINK;
  const [showMessage, setShowMessage] = useState(true);

  //cross function
  const handleDismiss = () => {
    setShowMessage(false);
  };

  return (
    <div className="">
      <div className="header border bg-[#ececec] w-full h-16 flex justify-center items-center">
        <p>Thank you for using our web Service!</p>
      </div>

      {showMessage && (
        <div className="flex  justify-around items-center gap-20 py-3 bg-red-400">
          <div className="h-[30px] text-white">
            <p className="mr-2 text-xl">
              Your browser does not meet the requirements.
            </p>
          </div>
          <Link
            to={devToolDownloadLink}
            target="_blank"
            rel="noopener noreferrer">
            <button className="flex justify-center text-white items-center gap-1 bg-blue-300 rounded-md py-1 px-2">
              Download Browser
              <GoDownload />
            </button>
          </Link>
        </div>
      )}

      <div className="flex justify-center items-center">
        <div className="body h-auto w-3/4 border flex flex-col justify-center rounded-t-md mt-7">
          <h1 className="text-xl font-bold mb-4 px-3 py-2 bg-gray-200">
            Browser Setup Guideline
          </h1>
          <div className="px-3">
            <p className="mb-4">Please make sure to follow these guidelines:</p>
            <ul className="list-disc ml-10 mb-4">
              <li className="mb-2">
                <div className="flex gap-2">
                  Ensure you are using a{" "}
                  <img src={LinuxImage} alt="" width={20} />
                  <b>Linux</b>(Debian,Ubunto,Pop...) operating system.
                </div>
              </li>
              <li className="mb-2">
                Use <b>DevTool</b> as your web browser.
              </li>
              <li className="mb-2">Make sure your browser is up to date.</li>
            </ul>
            <p>
              If you encounter any issues or have any questions, please
              don&apos;t hesitate to contact us.
            </p>
            <strong className="mb-5">
              Email:{" "}
              <span className="text-blue-500 underline font-normal">
                pyjin@gmail.com
              </span>
            </strong>
          </div>
          <h1 className="text-xl font-bold mb-4 px-3 py-2 bg-gray-200 mt-5">
            Operating System
          </h1>

          <p className="px-3">
            <p className="mb-2">
              We support Debian-based Linux operating systems such as Debian,
              Ubuntu, Mint, and Pop!_OS. For detailed instructions on installing
              these operating systems, please refer to the following links:
            </p>
            <ul className="list-disc ml-10 mb-4">
              <Link to={"https://www.debian.org/releases/buster/amd64/"}>
                <li className="mb-2 hover:text-blue-600 hover:underline">
                  Debian
                </li>
              </Link>
              <Link to={"https://ubuntu.com/server/docs/installation"}>
                <li className="mb-2 hover:text-blue-600 hover:underline">
                  Ubuntu
                </li>
              </Link>
              <Link
                to={
                  "https://linuxmint-installation-guide.readthedocs.io/en/latest/"
                }>
                <li className="mb-2 hover:text-blue-600 hover:underline">
                  Linux Mint
                </li>
              </Link>
              <Link to={"https://support.system76.com/articles/install-pop/"}>
                <li className="mb-2 hover:text-blue-600 hover:underline">
                  Pop!_OS
                </li>
              </Link>
            </ul>
          </p>
          <h1 className="text-xl font-bold mb-4 px-3 py-2 bg-gray-200 mt-5">
            Web Browser
          </h1>

          <div className="px-3">
            <p className="mb-3">
              We support only the DevTool web browser. Please ensure you have
              DevTool installed on your system before proceeding with our
              project. You can download DevTool from the following link:
            </p>

            <a
              href={devToolDownloadLink}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 text-blue-500">
              DevTool Browser Download...
            </a>

            <p className="mb-4 mt-3">
              You can also install by terminal command:{" "}
            </p>
            <pre className="text-[#6c6c6c] p-4 mb-4 border border-[#d3d3d3]">
              <code>sudo dpkg -i devtool.deb</code>
            </pre>

            <p className="mb-4">To Run: </p>
            <pre className="text-[#6c6c6c] p-4 mb-4 border border-[#d3d3d3]">
              <code>devtool</code>
            </pre>

            <p className="mb-2">To Uninstall:</p>
            <pre className="text-[#6c6c6c] p-4 mb-4 border border-[#d3d3d3]">
              <code>sudo dpkg -r devtool.deb</code>
            </pre>
          </div>
        </div>
      </div>
      <div>
        <p className="text-[14px] text-center text-gray-800 mt-10">
          By downloading and using Pyjin, you agree to the
          <span className="text-[#1068BF]"> license terms</span> and
          <span className="text-[#1068BF]"> privacy statement.</span>
        </p>
        <div className="flex justify-center items-center gap-8 mt-8 text-[15px] text-gray-600 py-6">
          <p>Terms</p>
          <p>Privacy</p>
          <p>Docs</p>
          <p className="font-medium">
            Contact P<span className="text-[#1068BF]">YJ</span>IN Support
          </p>
          <p>Manage cookies</p>
          <p>Do not share my personal information</p>
        </div>
      </div>
    </div>
  );
};

export default Guideline;
